module.exports = __webpack_public_path__ + "static/media/optimist- India.0e0445a7.png";